import gql from 'graphql-tag'

export const GLOBAL_REPORTS_QUERY = gql`
    query globalReports(
        $search: GlobalReportInputSearch!
    ) {
        globalReports(
            search: $search
        ) {
            id
            type
            metadata
            data
            report_date
            created_at
            updated_at
        }
    }
`
